import { UtilityModule } from "./UtilityModule";

export const utilityModules: UtilityModule[] = [];
